import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import Dashboard from './Dashboard';
import SignPage from './SignPage';
import InitiateRequest from './InitiateRequest';
import CreateTemplate from './CreateTemplate';
import DocumentDetailPage from './DocumentDetailPage';
import ApiKeysPage from './ApiKeysPage';
import WebhooksPage from './WebhooksPage';
import { pdfjs } from 'react-pdf';
import PrivateRoute from './PrivateRoute';
import VerifyDocument from './VerifyDocument';
import InvitePage from './InvitePage';
import { BrandingProvider } from './BrandingContext';
import { ThemeProvider } from './ThemeContext';
import { ToastProvider } from './ToastContext';
import './Global.css';

// FIX: Version 4.x requires the .mjs extension for the worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// REPLACE THIS WITH YOUR ACTUAL GOOGLE CLIENT ID FROM GOOGLE CLOUD CONSOLE
// Ideally, this should come from process.env.REACT_APP_GOOGLE_CLIENT_ID
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID";

function App() {
  return (
    <ThemeProvider>
      <BrandingProvider>
        <ToastProvider>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <Router>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/verify" element={<VerifyDocument />} />
              <Route path="/invite/:token" element={<InvitePage />} />
              {/* Protected Routes */}
              <Route path="/dashboard" element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } />

              <Route path="/initiate-request" element={
                <PrivateRoute>
                  <InitiateRequest />
                </PrivateRoute>
              } />

              {/* NEW ROUTE */}
              <Route path="/create-template" element={
                <PrivateRoute>
                  <CreateTemplate />
                </PrivateRoute>
              } />

              <Route path="/api-keys" element={
                <PrivateRoute>
                  <ApiKeysPage />
                </PrivateRoute>
              } />

              <Route path="/webhooks" element={
                <PrivateRoute>
                  <WebhooksPage />
                </PrivateRoute>
              } />

              <Route path="/sign/:referenceId" element={<SignPage />} />

              <Route path="/documents/:referenceId" element={
                <PrivateRoute>
                  <DocumentDetailPage />
                </PrivateRoute>
              } />

              {/* Root – logged-in users go to dashboard, others to login */}
              <Route path="/" element={
                <PrivateRoute>
                  <Navigate to="/dashboard" replace />
                </PrivateRoute>
              } />

              {/* Default fallback */}
              <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
          </Router>
        </GoogleOAuthProvider>
        </ToastProvider>
      </BrandingProvider>
    </ThemeProvider>
  );
}

export default App;